import { MenuItem, TextField } from '@material-ui/core';
import i18n from '../../../i18n';

import { WrappedFieldProps } from 'redux-form';
import { ProductDto } from 'types';

export interface SelectDiscountedItemControlFieldOwnProps {
    label: string;
    products: ProductDto[];
}

export type SelectDiscountedItemControlFieldProps = SelectDiscountedItemControlFieldOwnProps & WrappedFieldProps;

export const PromoDiscountItemField = (props: SelectDiscountedItemControlFieldProps) => {
    const { t } = i18n.useTranslation();
    const {
        input,
        label,
        products,
        meta: { touched, invalid, error },
    } = props;
    const errorMessage = touched && invalid ? t(error) : undefined;
    return (
        <TextField
            InputProps={{
                disableUnderline: true,
            }}
            type="number"
            variant="filled"
            select
            fullWidth={true}
            size="small"
            label={label}
            error={!!errorMessage}
            helperText={errorMessage}
            {...input}
        >
            {products.map(product => (
                <MenuItem key={product.productId} value={product.productId}>
                    <>{product.name}</>
                </MenuItem>
            ))}
        </TextField>
    );
};
